import { render, staticRenderFns } from "./PeopleDefaultIcon.vue?vue&type=template&id=5f3ca476&scoped=true"
import script from "./PeopleDefaultIcon.vue?vue&type=script&lang=ts"
export * from "./PeopleDefaultIcon.vue?vue&type=script&lang=ts"
import style0 from "./PeopleDefaultIcon.vue?vue&type=style&index=0&id=5f3ca476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3ca476",
  null
  
)

export default component.exports